import React from 'react';
import { css } from '@emotion/css';
import ApplicationModel from '../../models/applications/api/ApplicationModel';
import ApplicationContainer from '../../state/containers/ApplicationContainer';
import CurrentTemplateSelector from './components/CurrentTemplateSelector';
import ApplicationContentTree from '../applicationContentMenuPanel/components/ApplicationContentTree';
import FeatureContainer from '../../state/containers/FeatureContainer';
import { Subscribe } from 'unstated';
import ContentTreeStateContainer from '../../state/containers/ContentTreeStateContainer';
import { color_shades_dark, text_blue } from '../../constants/colors';
import SlideInSlideOutComponent from '../../components/structure/SlideInSlideOutComponent';
import AppliedAppTemplateMenu from '../applicationAppliedTemplates/components/AppliedAppTemplateMenu';
import AppliedApplicationTemplateContainer from '../../state/containers/AppliedApplicationTemplateContainer';
import TemplateConfigurationModel from '../../models/templating/api/TemplateConfigurationModel';

interface ApplicationContentMenuSelectorProps {
    applicationId: string
    history: any
    templateConfiguration: TemplateConfigurationModel
}
interface ApplicationContentMenuSelectorState {
    isExpanded: boolean
}
class ApplicationTemplateMenuSelector extends React.Component<ApplicationContentMenuSelectorProps, ApplicationContentMenuSelectorState> {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: false
        }
    }
    toggle() {
        this.setState({
            ...this.state,
            isExpanded: !this.state.isExpanded
        })
    }
    render() {
        return (
            <Subscribe to={[ApplicationContainer, AppliedApplicationTemplateContainer]}>
                {(appContainer: ApplicationContainer, appliedAppTemplateContainer: AppliedApplicationTemplateContainer) => (
                    <div className={`${containerStyle} ${this.state.isExpanded ? 'expanded' : ''}`}>
                        <CurrentTemplateSelector
                            onToggle={this.toggle.bind(this)}
                            isMinified={true}
                            isOpen={this.state.isExpanded}
                            templateConfiguration={this.props.templateConfiguration} />
                        <SlideInSlideOutComponent showChildren={this.state.isExpanded}
                            styleName="contentTreeDropdownSlide"
                            direction="down"
                            slideType="size">
                            <div className="fixed-tree-container">
                                <AppliedAppTemplateMenu history={this.props.history}
                                    applicationId={this.props.applicationId}
                                    appContainer={appContainer}
                                    appliedAppTemplateContainer={appliedAppTemplateContainer} />                                        
                            </div>
                        </SlideInSlideOutComponent>
                    </div>
                )}
            </Subscribe>
        )
    }
}

const containerStyle = css`
    height: 80px;
    padding-top: 16px;
    &.expanded {        
        background: ${text_blue};
    }
    .fixed-tree-container {
        margin-top: 80px;
        top: 0;
        left: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        position: fixed;
        max-height: calc(100% - 80px);
        width:288px;
        z-index: 3;
        background: white;
        border-right: 1px solid ${color_shades_dark};
    }
`

export default ApplicationTemplateMenuSelector;